import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import MinPlanPrice from "../../Components/MinPlanPrice";
import OperatingSystem from "../../Components/OperatingSystem";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function DedicatedServerIndia() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Affordable & Reliable Dedicated Server India Solutions 2026";
    sal();
  }, []);
  const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
        <Helmet>
            <title>Affordable & Reliable Dedicated Server India Solutions 2026</title>
            <meta name="description" content="Our dedicated server India offers powerful, secure, and scalable hosting solutions to keep your business online 24/7 effortlessly with expert support guaranteed" />
            <meta name="keywords" content="Best Dedicated Server In India, Dedicated Server Price In India, Server Cost In India, Best Dedicated Server Provider In India, Dedicated Server India" />
            <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/dedicated-server-india`} />
            <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/dedicated-server-india`} />
            <meta property="og:title" content="Budget-Friendly Dedicated Server in India for Every Business" />
            <meta property="og:description" content="Discover affordable dedicated servers in India, built for every business. Get exceptional performance & security customized for growth in the Indian market." />
        </Helmet>
        <section className="banner-bg bg-dark server-banner special-tilt-pb">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-xl-6">
                        <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            Local Servers. Faster Access.
                        </span>
                        <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            Nothing is 'Impossible' With Our Dedicated Server India
                        </h1>
                        <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            You’ve heard it too many times-“You get what you pay for.” This is not always true. For a long time, businesses have been stuck between selecting costly or affordable servers. Not anymore. This dedicated server India offers high speed & flexibility.
                        </p>
                        <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                    <span className="btn-arrow__text">
                                        Get Started
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </button>
                            <MinPlanPrice category="customizeddin" />
                        </div>
                        <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                    </div>
                    <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                        <img src="/images/we-took-the-impossible.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                    </div>
                </div>
            </div>
        </section>

        <section className="domain-container position-relative z-1 overflow-hidden special-domain-container">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-10">
                        <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                            <div className="card-body pt-60 pb-60">
                                <div className="row justify-content-center">
                                <div className="col-md-11 col-lg-10 col-xl-10">
                                    <div className="text-center">
                                        <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Premium-Level Hosting</span>
                                        <h4 className="mb-4">
                                            Dedicated Server India: For All Those Done with the Slow
                                        </h4>
                                        <p className="mb-6">
                                            Let’s be genuine-shared hosting can’t keep up with your struggle. Get a dedicated server in India that’s engineered to grow as quickly as you do. Flex hard, scale effortlessly, and never look back.
                                        </p>
                                        <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                            <span className="d-inline-block me-1 flex-shrink-0">
                                                <i className="las la-comments"></i>
                                            </span>
                                            <span className="btn-arrow__text">
                                                +91-7737300013
                                                <span className="btn-arrow__icon">
                                                    <i className="fa-solid fa-arrow-right"></i>
                                                </span>
                                            </span>
                                        </Link>
                                        <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                            <span className="d-inline-block me-1 flex-shrink-0">
                                                <i className="las la-comments"></i>
                                            </span>
                                            <span className="btn-arrow__text">
                                                Talk to an Expert
                                                <span className="btn-arrow__icon">
                                                    <i className="fa-solid fa-arrow-right"></i>
                                                </span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="service-area pt-100 pb-100">
            <div className="pb-40">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7">
                            <h2 className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Whatever You’re Chasing: Your Server Is For You</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row g-4">
                    <div className="col-lg-6 col-xl-4">
                        <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="400" data-sal-delay="100" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Own It All: From OS to Uptime</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img src="images/own-it-all-from.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>With the help of Best Dedicated Server India by Infinitive Host, you are in charge-complete access over everything from your operating system to your web server.</p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-4">
                        <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="450" data-sal-delay="150" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>High Traffic? No Problem</h6>
                                <div className="d-flex gap-5 flex-wrap flex-sm-nowrap mt-6">
                                    <div>
                                        <img src="images/high-traffic-no.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>Big traffic? Heavy tasks? No issues with our dedicated servers. Get lightning-fast performance with 10 Gbps speed on our robust dedicated server India.</p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-4">
                        <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>IG Feeds Flex, You Host It Best</h6>
                                <div className="d-flex flex-wrap flex-sm-nowrap gap-5 mt-6">
                                    <div>
                                        <img src="images/IG-feeds-flex.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>Wait, wait… What if we told you… you could have total server control from the very first day? Sounds impossible, but with our dedicated server hosting, nothing is impossible.</p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Built to Flex When Others Fail</h6>
                                <div className="d-flex flex-wrap flex-sm-nowrap gap-5 mt-6">
                                    <div>
                                        <img src="images/built-to-flex.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>You’ve outperformed the shared space and the “almost enough” setups. It’s the time for a dedicated server India that always keeps you up with your ambitions & your struggle.</p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                        <div className="card service-card-item shadow-sm rounded-3 h-100 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <div className="card-body px-md-7 py-md-8">
                                <h6>Live in Hours, Not Hype</h6>
                                <div className="d-flex flex-wrap flex-sm-nowrap gap-5 mt-6">
                                    <div>
                                        <img src="images/live-in-hours.webp" alt="" />
                                    </div>
                                    <div>
                                        <p>Big goals shouldn’t be simply paused by messy and slow setups. With dedicated server hosting, you go from fully booked to live before you even blink. Hustle, non-stop.</p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="price-plan-section pt-100 pb-100">
            <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
            <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8">
                            <div className="text-center">
                                <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                                <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> The Server Behind Your Dreams.</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PlanList category={'customizeddin'}/>
        </section>

        <div className="pt-60 pb-80">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-xl-6">
                        <div className="text-center sal-animate" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <img src="images/migrate-img-1.png" alt="image" className="img-fluid" />
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <h2 className="mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            Something Powerful Just Dropped in India…
                        </h2>
                        <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            And you know what it’s engineered for: businesses just like yours. Infinitive Host’s dedicated server India gives everything you’ve been manifesting for so long
                        </p>
                        <div className="row g-4">
                            <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <div className="card shadow-lg h-100">
                                    <div className="card-body">
                                        <div className="mb-8">
                                            <img src="images/site’s-passport.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-5">
                                            Site’s Passport to Speed
                                        </h6>
                                        <p className="mb-0">
                                            Want to go live globally without going slow? Select from our international data centers and serve your target audience like a legend-quick, smooth, and always live.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <div className="card shadow-lg h-100">
                                    <div className="card-body">
                                        <div className="mb-8">
                                            <img src="images/who’s-watching.webp" alt="image" className="img-fluid" />
                                        </div>
                                        <h6 className="mb-5">
                                            Who’s Watching Your Data?
                                        </h6>
                                        <p className="mb-0">
                                            In this era, you never know who’s watching and who’s not. With our dedicated server India, you’re the real boss-full access, no sharing, zero compromises.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="container responsive-pt-50 pb-40 responsive-pb-50">
            <div className="row">
                <div className="col-12">
                    <div className="bg-dark px-sm-10 px-6 pt-80 pb-80 rounded-3">
                        <div className="pb-40">
                            <div className="row justify-content-center">
                                <div className="col-md-10 col-lg-10 col-xl-7">
                                    <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                        <span className="section-title-dark style-bg fadeInUp">No More Stress & Downtime</span>
                                        <h2 className="h4 text-white mb-3">Lost Sleep Over Downtime? Same. Till Now.</h2>
                                        <p className="text-white max-text-60 mx-auto mb-0 text-opacity-75">Before Infinitive Host’s benefit, every single crash felt like a heart attack. Shifting to dedicated server hosting in India, your site stays live & crash-free.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row g-4">
                            <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <div className="px-5 py-7 rounded-3 side-blog-item transition bg-white bg-opacity-5 h-100">
                                    <img src="images/high-traffic-we-love.webp" alt="image" className="img-fluid mb-3" />
                                    <h6 className="text-white mb-3">High Traffic? We Love That for You.</h6>
                                    <p className="text-white mb-0 text-opacity-75">Our Dedicated Server India comes loaded with DDR4 memory, SSD storage, & Intel & AMD processors-so your site stays secure.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <div className="px-5 py-7 rounded-3 side-blog-item transition bg-white bg-opacity-5 h-100">
                                    <img src="images/one-click-endless.webp" alt="image" className="img-fluid mb-3" />
                                    <h6 className="text-white mb-3">One Click. Endless Possibilities.</h6>
                                    <p className="text-white mb-0 text-opacity-75">Begin your journey without any issue. With our dedicated server hosting, just launch Drupal, WordPress, Magento, or Prestashop in 1-click.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <div className="px-5 py-7 rounded-3 side-blog-item transition bg-white bg-opacity-5 h-100">
                                    <img src="images/CBlink-&-look.webp" alt="image" className="img-fluid mb-3" />
                                    <h6 className="text-white mb-3">CBlink & Look It's Live</h6>
                                    <p className="text-white mb-0 text-opacity-75">At whatever level you are running your site, get the high speed. With custom-built open-source technology, upgrade your servers.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <div className="px-5 py-7 rounded-3 side-blog-item transition bg-white bg-opacity-5 h-100">
                                    <img src="images/engineered-for-all.webp" alt="image" className="img-fluid mb-3" />
                                    <h6 className="text-white mb-3">Engineered for All the Hustle</h6>
                                    <p className="text-white mb-0 text-opacity-75">Our server has vast processing power since it utilizes enterprise-level hardware. You’ll be fully able to get the best out of your site.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <div className="px-5 py-7 rounded-3 side-blog-item transition bg-white bg-opacity-5 h-100">
                                    <img src="images/zero-chill-on.webp" alt="image" className="img-fluid mb-3" />
                                    <h6 className="text-white mb-3">Zero Chill on Support</h6>
                                    <p className="text-white mb-0 text-opacity-75">As no one loves to wait. Don’t worry, once the order is placed & accepted, the dedicated server India will be installed by our experts.</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                                <div className="px-5 py-7 rounded-3 side-blog-item transition bg-white bg-opacity-5 h-100">
                                    <img src="images/admin-goals.webp" alt="image" className="img-fluid mb-3" />
                                    <h6 className="text-white mb-3">Admin Goals Unlocked</h6>
                                    <p className="text-white mb-0 text-opacity-75">Host a dedicated server with full access, which gives you control over your server and the ability to personalize and set up your server.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <OperatingSystem/>
        
        <section className="simple-box-section pt-60 pb-100 responsive-pt-50">
      <div className="container">
        <div className="row">
            <div className="col-12">
                <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card-body px-6 pt-60 pb-60">
                        <div className="row justify-content-center">
                            <div className="col-md-11 col-lg-8 col-xl-8">
                                <div className="text-center">
                                  <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Built to Stand Out</span>
                                    <h4 className="mb-4">
                                        Go From Offline to Prime-Time
                                    </h4>
                                    <p className="mb-6">
                                      Your business? Your server? Better be fire too. Time for glow-up.
                                    </p>
                                    <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded">
                                        <span className="d-inline-block me-1 flex-shrink-0">
                                            <i className="las la-comments"></i>
                                        </span>
                                        <span className="btn-arrow__text">
                                            Go Live Now
                                            <span className="btn-arrow__icon">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
        </section>
    </>
  );
}
